import { commonApi } from '@/common/index';
export default {
  data() {
    return {}
  },
  methods: {
    _getMsgLists(param = {}) {
      // 查询未读的消息总条数
      const params = Object.assign({}, { pageNo: 1, pageSize: 1 }, param)
      commonApi.VIP.getMsgSiteList(params).then(data => {
        if (this.publishInfo !== undefined) this.publishInfo = data.list
        if (params.read && params.read === 0) this.setInEmailNum(data.total)
      }).catch(err => {
        if (params.read && params.read === 0) this.setInEmailNum(0)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/mixins/getMsg.js